<template>
  <div class="rg-device">
    <single-mod :mod="curMod" :valueOp="valueOp" :rightEchart="rightEchart">
      <template v-slot="wsData">
        <div
          class="device-info"
          v-if="
            wsData.singleDeviceDetail &&
            wsData.singleDeviceDetail.mods &&
            wsData.singleDeviceDetail.mods[curMod]
          "
        >
          <el-row>
            <el-col :span="12">
              <span>设备状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.state | stateClass(true)">
                {{ wsData.singleDeviceDetail.state | stateText }}
              </span>
            </el-col>
            <el-col :span="12">
              <span>运行状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.runstate | runstateClass(true)">
                {{ wsData.singleDeviceDetail.runstate | runstateText }}
              </span>
            </el-col>
          </el-row>
          <el-row>
            <div
              style="
                width: 50%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                font-size: 26px;
              "
            >
              <ModsIcon icon="icon-he" :wsData="wsData.singleDeviceDetail" :mods="curMod" />
            </div>
          </el-row>
          <el-row>
            <div style="margin-bottom: 10px">设备名称: {{ wsData.singleDeviceDetail.name }}</div>
            <div>设备编号: {{ wsData.singleDeviceDetail.sn }}</div>
          </el-row>
        </div>
      </template>
    </single-mod>
  </div>
</template>

<script>
import SingleMod from '../components/single-mod';
import ModsIcon from '@/components/mods-icon';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';

export default {
  name: 'RG500',
  components: {
    SingleMod,
    ModsIcon
  },
  data() {
    return {
      curMod: 'nuclearMod',
      valueOp: [
        {
          title: 'γ射线(μSv/h)',
          key: 'radDose'
        },
        {
          title: 'αβ射线(Bq/cm²)',
          key: 'radBeta'
        }
      ],
      rightEchart: [
        lineAreaStyle({
          color: '#833BBB',
          title: { text: 'γ射线(μSv/h)' },
          series: [
            { areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') } }
          ]
        }),
        lineAreaStyle({
          color: '#3368F2',
          title: { text: 'αβ射线(Bq/cm²)' },
          series: [
            { areaStyle: { color: graColor('rgba(51, 104, 242, 0.5)', 'rgba(51, 104, 242, 0)') } }
          ]
        })
      ]
    };
  }
};
</script>

<style lang="scss">
.rg-device {
  height: 100%;
  .device-info {
    height: 100%;
    color: #00a0e9;
    font-size: 26px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .state {
      @include state-textstyle;
    }
  }
  .el-row {
    text-align: center;
  }
}
</style>
